import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Search, Package } from "lucide-react";

export default function TrackOrder() {
  const { order_number: initial } = useParams();
  const [num, setNum] = useState(initial || "");
  const [contact, setContact] = useState("");
  const [order, setOrder] = useState(null);
  const [err, setErr] = useState("");

  const lookup = async (e) => {
    e?.preventDefault?.();
    setErr("");
    setOrder(null);
    if (!num.trim() || !contact.trim()) { setErr("Please enter both order number and email/mobile"); return; }
    try {
      const { data } = await api.post(`/orders/track`, { order_number: num.trim(), contact: contact.trim() });
      setOrder(data);
    } catch (e) {
      setErr(formatApiError(e.response?.data?.detail));
    }
  };

  return (
    <div className="container-x py-16 max-w-3xl" data-testid="track-page">
      <h1 className="font-serif text-4xl md:text-5xl mb-2">Track your order</h1>
      <p className="text-sm text-muted-foreground mb-8">No login needed. Enter your order number and the email or mobile you used to place the order.</p>
      <form onSubmit={lookup} className="grid md:grid-cols-[1fr_1fr_auto] gap-2 mb-6">
        <input value={num} onChange={(e)=>setNum(e.target.value)} placeholder="Order number e.g. ADI-2026-000001" className="border hairline rounded-full px-5 py-3 bg-white outline-none text-sm" data-testid="track-order-input" />
        <input value={contact} onChange={(e)=>setContact(e.target.value)} placeholder="Email or mobile" className="border hairline rounded-full px-5 py-3 bg-white outline-none text-sm" data-testid="track-contact-input" />
        <button className="btn-gold rounded-full px-6 py-3 text-xs uppercase tracking-widest flex items-center justify-center gap-2" data-testid="track-submit"><Search className="w-4 h-4" strokeWidth={1.5} /> Track</button>
      </form>
      {err && <div className="text-sm text-destructive mb-4">{err}</div>}
      {order && (
        <div className="border hairline rounded-xl p-6 bg-white">
          <div className="flex justify-between items-center mb-4">
            <div>
              <div className="font-serif text-2xl">{order.order_number}</div>
              <div className="text-xs text-muted-foreground">{new Date(order.created_at).toLocaleString()}</div>
            </div>
            <div className="text-right">
              <div className="font-serif text-2xl gold-text">₹{order.total}</div>
              <div className="text-xs capitalize">{order.status.replace(/_/g, " ")}</div>
            </div>
          </div>
          <div className="border hairline rounded-lg p-4 mb-4 text-sm">
            <div className="flex items-center gap-2 font-medium mb-2"><Package className="w-4 h-4 gold-text" strokeWidth={1.5} /> Tracking</div>
            <div className="text-muted-foreground">Courier: {order.tracking?.courier || "—"}</div>
            <div className="text-muted-foreground">Tracking Number: {order.tracking?.tracking_number || "—"}</div>
            {order.tracking?.tracking_url && <a target="_blank" rel="noopener noreferrer" href={order.tracking.tracking_url} className="gold-text underline">Open tracking</a>}
          </div>
          <div className="space-y-2">
            {(order.history || []).map((h, i) => (
              <div key={i} className="flex items-center gap-3 text-sm">
                <div className="w-2 h-2 rounded-full bg-[#B8860B]"></div>
                <div className="capitalize">{h.status.replace(/_/g, " ")}</div>
                <div className="text-xs text-muted-foreground ml-auto">{new Date(h.at).toLocaleString()}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
